import { Link, useLocation } from 'react-router-dom';
import Aside from '../aside';
import { useDispatch, useSelector } from 'react-redux';
import { GetReport, GetUserDetails } from '../../../../store/actions/kalapost';
import download from 'downloadjs';
import { toggleSidebar } from '../../../../store/actions/layout';
import { useEffect } from 'react';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { seperateNumber } from '../../../../utils/numbers';
const OrdersDetails = () => {
   const { trackingNumber } = useParams();

   const dispatch = useDispatch();
   const [details, setDetails] = useState({
      assurance: {},
      deliveryType: '',
      destination: '',
      origin: '',
      packages: [],
      packing: [],
      paymentStat: null,
      paymentTime: '',
      paymentType: '',
      price: '',
      recepientAddress: '',
      recepientName: '',
      recepientPhoneNumber: '',
      recepientPostalCode: null,
      senderAddress: '',
      senderName: '',
      senderPhoneNumber: '',
      serviceFee: {},
      serviceType: '',
      status: '',
      statusId: 0,
      theDate: '',
      theTime: '',
      trackingNumber: '',
   });

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);
   const { isSidebarOpened } = useSelector((state) => state.layout);
   const GetDataDetails = async () => {
      const res = await GetUserDetails(trackingNumber);
      res.status && setDetails(res.data);
   };
   const handleGetReport = async () => {
      const res = await GetReport(trackingNumber);
      const pdfName = res.data.type.split('/')[0];
      res.status && res.data && download(res.data, pdfName);
   };
   useEffect(() => {
      GetDataDetails();
   }, []);

   return (
      <section className='container'>
         <div className='container__row'>
            <Aside />
            <main
               className='main__container'
               onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
            >
               <div className='orders-details'>
                  <div className='cards__header cards__header--orders-details'>
                     <Link to='/orders' className='back'>
                        <img src='/img/right-arrow-3558_prev_ui.png' alt='back' />
                     </Link>
                     <div>
                        <span>زمان ثبت</span>
                        <span>{details.theTime}</span>
                     </div>
                     <div>
                        <span>کد رهگیری</span>
                        <span>{details.trackingNumber}</span>
                     </div>
                     <span className='cards__situation'>{details.status}</span>
                  </div>

                  <section className='orders-details__info'>
                     <div className='orders-details__list'>
                        <div className='orders-details__row'>
                           <span className='orders-details__title'>روش ارسال :</span>
                           <span className='orders-details__item'>{details.serviceType}</span>
                        </div>

                        <div className='orders-details__row'>
                           <span className='orders-details__title'>نوع تحویل :</span>
                           <span className='orders-details__item'>{details.deliveryType}</span>
                        </div>

                        <div className='orders-details__row'>
                           <span className='orders-details__title'>نام گیرنده :</span>
                           <span className='orders-details__item'>{details.recipientName}</span>
                        </div>

                        <div className='orders-details__row'>
                           <span className='orders-details__title'>شماره تلفن همراه :</span>
                           <span className='orders-details__item'>
                              {details.recipientPhoneNumber}
                           </span>
                        </div>

                        <div className='orders-details__row'>
                           <span className='orders-details__title'>آدرس :</span>
                           <span className='orders-details__item'>{details.recipientAddress}</span>
                        </div>
                     </div>

                     <div className='orders-details__list'>
                        <div className='orders-details__row'>
                           <span className='orders-details__title'>شهر مبدا :</span>
                           <span className='orders-details__item'>{details.origin}</span>
                        </div>

                        <div className='orders-details__row'>
                           <span className='orders-details__title'>نام فرستنده :</span>
                           <span className='orders-details__item'>{details.senderName}</span>
                        </div>
                        <div className='orders-details__row'>
                           <span className='orders-details__title'>کد ملی :</span>
                           <span className='orders-details__item'>
                              {details.recipientNationalId}
                           </span>
                        </div>
                        <div className='orders-details__row'>
                           <span className='orders-details__title'>شهر مقصد :</span>
                           <span className='orders-details__item'>{details.destination}</span>
                        </div>
                        <div className='orders-details__row'>
                           <span className='orders-details__title'>کد پستی :</span>
                           <span className='orders-details__item'>
                              {details.recipientPostalCode}
                           </span>
                        </div>
                     </div>
                  </section>
                  <section className='orders-details__lists'>
                     <div>
                        <h2 className='orders-details__part-head'>لیست کالاها</h2>
                        <div className='orders__specs-row-head'>
                           <span className='orders__specs-object'>عنوان</span>
                           <span className='orders__specs-object'>ابعاد</span>
                           <span className='orders__specs-object'>وزن(kg)</span>
                           <span className='orders__specs-object'>تعداد</span>
                           <span className='orders__specs-object'>شکستنی</span>
                        </div>
                        <div className='orders__scroll'>
                           {details.packages.map((item, index) => {
                              return (
                                 <div className='orders__specs-row' key={index}>
                                    <span className='orders__specs-object'>{item.title}</span>
                                    <span className='orders__specs-object'>
                                       {item.typeAndSize.title}
                                    </span>
                                    <span className='orders__specs-object'>{item.weight}</span>
                                    <span className='orders__specs-object'>{item.number}</span>
                                    <span className='orders__specs-object'>
                                       {item.isFragile ? (
                                          <img
                                             style={{ width: '20px' }}
                                             src='/img/check-green.svg'
                                             alt='check'
                                          />
                                       ) : (
                                          <img
                                             style={{ width: '20px' }}
                                             src='/img/close.svg'
                                             alt='delete'
                                          />
                                       )}
                                    </span>
                                 </div>
                              );
                           })}
                        </div>
                     </div>
                  </section>

                  <section className='orders-details__cost-items'>
                     <div className='orders-details__cost-item'>
                        <label className='orders-details__cost-title'>بیمه :</label>
                        <span className='orders-details__cost-reply'>
                           {details.assurance.stat ? 'دارد' : 'ندارد'}
                        </span>
                     </div>

                     <div className='orders-details__cost-item'>
                        <label className='orders-details__cost-title'>ارزش کالا :</label>
                        <span className='orders-details__cost-reply'>
                           {details.assurance.value
                              ? seperateNumber(details.assurance.value + '')
                              : '0'}{' '}
                           تومان
                        </span>
                     </div>
                  </section>

                  <section className='orders-details__cost-items '>
                     <div className='orders-details__cost-item'>
                        <label className='orders-details__cost-title'>خدمات :</label>
                        <span className='orders-details__cost-reply'>
                           {details.serviceFee.stat ? 'دارد' : 'ندارد'}
                        </span>
                     </div>
                     <div className='orders-details__cost-item'>
                        <label className='orders-details__cost-title'> هزینه خدمات :</label>
                        <span className='orders-details__cost-reply'>
                           {details.serviceFee.value ? details.serviceFee.value : '0'}
                        </span>
                     </div>
                     <div className='orders-details__cost-item'>
                        <label className='orders-details__cost-title'>توضیحات خدمات :</label>
                        <span className='orders-details__cost-reply'>
                           {details.serviceFee.desc ? details.serviceFee.desc : 'توضیحی ندارد'}
                        </span>
                     </div>
                  </section>

                  <section className='orders-details__lists'>
                     <h2 className='orders-details__part-head'>اقلام بسته بندی مورد نیاز</h2>
                     <div className='orders-details__selector'>
                        {details.packing.length === 0 ? (
                           <div className='orders-details__btn orders-details__btn--empty'>
                              <p>اقلامی موجود نیست</p>
                           </div>
                        ) : (
                           details.packing.map((item, index) => {
                              return (
                                 <div className='orders-details__btn' key={index}>
                                    <p>{item.typeName}</p>
                                    <span className='orders-details__circle'>{item.count}</span>
                                 </div>
                              );
                           })
                        )}
                     </div>
                  </section>
               </div>

               <section className='orders-details__final'>
                  <div className='orders-details__final-list'>
                     <div className='orders-details__row'>
                        <span className='orders-details__title orders-details__title--final'>
                           مبلغ سفارش :
                        </span>
                        <span className='orders-details__item orders-details__item--final'>
                           {seperateNumber(details.price + '')} ریال
                        </span>
                     </div>
                     <div className='orders-details__row'>
                        <span className='orders-details__title orders-details__title--final'>
                           شماره پیگیری :
                        </span>
                        <span className='orders-details__item orders-details__item--final'>
                           {details.paymentType === 'کیف پول' || details.paymentType === 'در محل'
                              ? '-------'
                              : '54869'}
                        </span>
                     </div>
                     <div className='orders-details__row'>
                        <span className='orders-details__title orders-details__title--final'>
                           نوع پرداخت :
                        </span>
                        <span className='orders-details__item orders-details__item--final'>
                           {details.paymentType}
                        </span>
                     </div>
                     <div className='orders-details__row'>
                        <span className='orders-details__title orders-details__title--final'>
                           زمان پرداخت :
                        </span>
                        <span className='orders-details__item orders-details__item--final'>
                           {details.paymentTime}
                        </span>
                     </div>
                     <div className='orders-details__row'>
                        <span className='orders-details__title orders-details__title--final'>
                           تاریخ :
                        </span>
                        <span className='orders-details__item orders-details__title--final'>
                           {details.theDate}
                        </span>
                     </div>
                  </div>

                  <p
                     className='btn btn--Primary btn--Primary-orders-details'
                     onClick={handleGetReport}
                  >
                     دریافت رسید
                  </p>
               </section>
            </main>
         </div>
      </section>
   );
};

export default OrdersDetails;
